import { render, staticRenderFns } from "./Notas.vue?vue&type=template&id=c30270d2"
import script from "./Notas.vue?vue&type=script&lang=js"
export * from "./Notas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports